import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { IFilterParams } from 'ag-grid-community'
import BHSelect from '../inputs/BHSelect'

interface Props extends IFilterParams {
  children: React.ReactNode
}

const productTypes = ['chaseCover', 'topMount', 'outsideMount']

// Function to convert camelCase to Title Case
const camelCaseToTitleCase = (camelCase: string) => {
  const result = camelCase.replace(/([A-Z])/g, ' $1')
  return result.charAt(0).toUpperCase() + result.slice(1)
}

const ProductTypeFilter = forwardRef<any, Props>((props, ref) => {
  const [selectedProductType, setSelectedProductType] =
    useState<Maybe<ProductType>>(null)

  // Expose AG Grid Filter Lifecycle callbacks
  useImperativeHandle(ref, () => ({
    isFilterActive() {
      return selectedProductType !== null
    },

    doesFilterPass(params: any) {
      const { node } = params
      const { api, colDef, column, columnApi, context } = props
      const value = props.valueGetter({
        api,
        colDef,
        column,
        columnApi,
        context,
        data: node.data,
        getValue: (field) => node.data[field],
        node,
      })

      return value === selectedProductType
    },

    getModel() {
      return this.isFilterActive() ? { value: selectedProductType } : null
    },

    setModel(model: any) {
      setSelectedProductType(model ? model.value : null)
    },
  }))

  const onChange = (value: number) => {
    if (value === -1) {
      setSelectedProductType(null)
      return
    }

    const productType = productTypes[value] as ProductType
    setSelectedProductType(productType)
  }

  useEffect(() => {
    props.filterChangedCallback()
  }, [selectedProductType])

  return (
    <div className="p-4 w-[200px]" style={{ padding: 4, width: 200 }}>
      <BHSelect
        key="productType"
        title=""
        currentValue={productTypes.indexOf(selectedProductType ?? '') ?? null}
        onChange={onChange}
        options={[
          { label: '---', value: -1 },
          ...productTypes.map((type, i) => ({
            label: camelCaseToTitleCase(type),
            value: i,
          })),
        ]}
      />
    </div>
  )
})

ProductTypeFilter.displayName = 'ProductTypeFilter'

export default ProductTypeFilter
